<template>
    <div>
        <div id="worksends-page-header" class="tw-grid tw-mt-2 tw-grid-cols-2">
            <div>
                <div class="breadcrumbs" id="breadcrumbs">
                    <router-link class="breadcrumb-link" to="/orders/">BookBlock Orders & Jobs</router-link>
                </div>
                <h3 v-if="type === 'jobs'">BookBlock Orders & Jobs</h3>
                <h3 v-if="type === 'enquiries'">BookBlock Enquiries</h3>
                <div class="ws-button ws-button-main" @click="modals.omsEnquiryModal = true">Make New Enquiry</div>
            </div>
            <div class="ws-filters tw-flex tw-justify-end">
                <div v-if="type === 'jobs'" class="ws-filter ws-filter-select">
                    <label>Order Status</label>
                    <select v-model="pageParams.filters.status.val" @change="setFilter(null)" >
                        <option value="null">All Order Statuses</option>
                        <option v-for="(label, status) in jobStatuses" :value="status" >{{ label }}</option>
                    </select>
                </div>

                <div v-if="type === 'enquiries'" class="ws-filter ws-filter-select">
                    <label>Enquiry Status</label>
                    <select v-model="pageParams.filters.status.val" @change="setFilter(null)" >
                        <option value="null">All Enquiry Statuses</option>
                        <option v-for="(label, status) in enquiryStatuses" :value="status" >{{ label }}</option>
                    </select>
                </div>

                <div v-if="type === 'enquiries'" class="ws-filter ws-filter-select">
                    <label>Enquiry Source</label>
                    <select v-model="pageParams.filters.enquiry_source.val" @change="setFilter(null)" >
                        <option value="null">All Enquiry Sources</option>
                        <option v-for="(label, source) in enquirySources" :value="source" >{{ label }}</option>
                    </select>
                </div>

                <div class="ws-filter ws-filter-search">
                    <label>Search orders</label>
                    <input type="text" v-model="pageParams.search.val" @keyup="setFilter(null)" placeholder="Search...">
                </div>
            </div>
        </div>
        <!--<div class="worksends-scrollable-table-wrap" style="margin-bottom: 50px">-->
            <table id="list-of-oms-orders"  class="worksends-table worksends-table-orders">
                <thead>
                <tr>
                    <th class="field-name">Order & Job Name</th>
                    <th class="field-quantity">Units</th>
                    <th class="field-status">Status</th>
                    <th class="field-customer-pack">Last Customer Pack</th>
                    <th v-if="type==='jobs'" class="field-production-progress">Production Progress</th>
                    <th v-if="type==='enquiries'" class="field-invoices">Invoices</th>
                    <th v-if="type==='enquiries'" class="field-enquiry-source">Enquiry Source</th>
                    <th v-if="type==='jobs'" class="field-completion-date">Completion Date</th>
                    <th v-if="type==='enquiries'" class="field-date-created">Date Created</th>
                    <!--<th class="field-delivery-date">Delivery Date</th>-->
                    <th class="field-actions">Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in index.data" v-bind:key="item.id">
                    <td class="field-id" data-label="Job & Order Name">
                        <div v-if="type==='jobs'">Order {{ item.order_name }} <span class="semi-id">- #{{ item.order_id }}</span></div>
                        <div style="font-size: 16px">
                            <router-link :to="'/orders/' + item.id">
                                <b>{{ item.name }}</b> <span class="semi-id">- #{{ item.id }}</span>
                            </router-link>
                        </div>
                    </td>
                    <td class="field-quantity" data-label="Quantity">
                        <div style="font-size: 16px"><b>{{ item.quantity }}</b></div>
                    </td>
                    <td v-if="type==='jobs'" class="field-status" data-label="Job Status">
                        <div :class="'status status-'+item.status">{{ statusName(item.status) }}</div>
                    </td>
                    <td v-if="type==='enquiries'" class="field-status" data-label="Enquiry Status">
                        <div :class="'status status-'+item.status">{{ enquiryStatusName(item.status) }}</div>
                    </td>
                    <td class="field-customer-pack" data-label="Last Customer Pack">
                        <a v-if="item.customer_packs[0]" target="_blank" :href="'/docs/pack/' + item.customer_packs[0].key">
                            <div class="oms-file-icon"><div class="text">CP</div></div>
                            <div class="version">Version # {{ item.customer_packs[0].version }}</div>
                            <div :class="'cp-status cp-status-' + item.customer_packs[0].status">{{ item.customer_packs[0].status }}</div>
                        </a>
                        <i v-else>-</i>
                    </td>
                    <td v-if="type==='jobs'" class="field-production-progress" data-label="Production Progress">
                        <div class="production-progress"  v-if="item.production_steps?.total">
                            <doughnut-chart :width="32" :height="32" :options="chartOptions" :chart-data="donughtChartData(item.production_steps)"></doughnut-chart>
                            <b>{{ Math.round((item.production_steps.finished / item.production_steps.total) * 100) }}%</b>
                        </div>
                    </td>
                    <td v-if="type==='enquiries'" class="field-invoices" data-label="Invoices">
                        <a :href="downloadLink(invoice.public_key)" class="invoice" v-for="invoice in item.invoices" v-bind:key="invoice.id">
                            <div class="oms-file-icon"><div class="text">PDF</div></div>
                            <div style="font-weight: bold">{{ invoice.name }}</div>
                            <div :class="'invoice-status status-'+invoice.status">{{ invoice.status==='part'? 'Partly Paid' : invoice.status }}</div>
                        </a>
                    </td>
                    <td v-if="type==='enquiries'" class="field-enquiry-source" data-label="Enquiry Source">
                        <div class="enquiry-source">{{ enquirySourceName(item.enquiry_source) }}</div>
                    </td>
                    <td v-if="type==='jobs'" class="field-completion-date" data-label="Completion Date">
                        {{ (item.finished_at ?? item.planned_finish ?? item.deadline) | moment("DD/MM/YY") }}
                        <span v-if="!item.finished_at" class="estimate">(est.)</span>
                    </td>
                    <td v-if="type==='enquiries'" class="field-date-created" data-label="Date Created">
                        {{ item.created_at | moment("DD/MM/YY") }}
                    </td>
                    <td class="field-actions" data-label="Actions">
                        <router-link :to="'/orders/' + item.id" class="ws-button small">View Details</router-link>
                    </td>
                </tr>
                </tbody>
            </table>
        <!--</div>-->
        <enquiry-modal v-if="modals.omsEnquiryModal"></enquiry-modal>
    </div>
</template>

<script>
import moment from "moment";
import DoughnutChart from "@/components/charts/DoughnutChart.vue";
import EnquiryModal from '@/pages/orders/EnquiryModal';
 
export default {
    name: "OMSJobIndex",
    components: {DoughnutChart, EnquiryModal},
    data: () => ({
        type: '',
        lazyLoading: false,
        requestItems: null,
        expandedUpdates: {},
        expandedRequests: {},
        selectFilterOrderStatuses: ['due','processing','sent','delivered','returning to sender','re-sent','received return','problem'],
        pageParams: {
            pageOptions: {page:1, sortBy:[], sortDesc:[], itemsPerPage: 50},
            search: {val: ""},
            filters: {
                status: { val: null, type: 'single' },
                enquiry_source: { val: null, type: 'single' },
            }
        },
        chartOptions: {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
                display: false
            },
            cutoutPercentage: 40,
            tooltips: {
                enabled: false
            }
        },
        
    }),
    methods: {
        async getPage(params = {}) {
            await this.getPageHandler({
                waitName: 'oms.jobs',
                action: 'fetchOMSJobs', // vuex action
                pageParams: this.pageParams,
                isInit: params.init !== 'undefined' ? params.init : false, // parse from url query params
                pushRoute: params.pushRoute !== 'undefined' ? params.pushRoute : true, // push pagination params and search q to route
                resetPagination: params.resetPagination !== 'undefined' ? params.resetPagination : false, // new search input -> need to reset page & sorting
                routeParams: params.routeParams !== 'undefined' ? params.routeParams : false, // extra params
                noWait: params.noWait !== 'undefined' ? params.noWait : false // extra params
            });
        },
        async setFilter(param = null, val = null) {
            if (param) this.pageParams.filters[param].val = val;
            await this.getPage({resetPagination: true, routeParams: {type: this.type}});
        },
        donughtChartData(data) {
            return {
                labels: ['Complete','Remaining'],
                datasets: [{
                    backgroundColor: ['#5DAEB7','#dddddd'],
                    data: [
                        data.finished,
                        data.total-data.finished
                    ]
                }]
            };
        },
        statusName(name) {
            return this.jobStatuses[name] ?? name;
        },
        enquiryStatusName(name) {
            return this.enquiryStatuses[name] ?? name;
        },
        enquirySourceName(name) {
            return this.enquirySources[name] ?? name;
        },
        downloadLink(key) {
            return process.env.VUE_APP_OMS_BASE_URL+'/worksends-documents/attachments/'+key;
        }
    },
    mounted() {
        this.type = this.$route.meta?.type ?? 'jobs';
        this.getPage({init:true, routeParams: {type: this.type}});
    },
    computed: {
        moment() {
            return moment
        },
        index() {
            return this.$store.state.oms.jobs;
        },
        modals() {
            return this.$store.state.modals;
        },
        jobStatuses() {
            return this.$store.state.oms.jobStatuses;
        },
        enquiryStatuses() {
            return this.$store.state.oms.enquiryStatuses;
        },
        enquirySources() {
            return this.$store.state.oms.enquirySources;
        }
    },
   
}
</script>

<style scoped>
.semi-id {
    opacity: 0.4;
}

.status {
    text-transform: uppercase;
    padding: 5px 12px;
    background: #E1E1E1;
    letter-spacing: 0.05em;
    display: inline-block;
    border-radius: 4px;
    font-size: 12px;
}

.status-hold,
.status-enquiry_payment {
    background: #FACECE;
}


.status-draft,
.status-enquiry_fresh,
.status-awaiting_production {
    background: #E1E1E1;
}

.status-ordered,
.status-enquiry_progress {
    background: #FAEDCE;
}

.status-qc,
.status-enquiry_invoice {
    background: #ECCCF1;
}

.status-production_done,
.status-packaging,
.status-enquiry_ready {
    background: #B3D6F5;
}

.status-sent {
    background: #DEECEE;
}

.status-completed {
    background: #C7DDE0;
}

.estimate {
    font-style: italic;
    color: #E89D6B;
}

.field-customer-pack a {
    padding-left: 30px;
    position: relative;
    display: block;
    line-height: 18px;
}

.oms-file-icon {
    background: rgb(26, 131, 179);
    border-radius: 5px 0 3px 3px;
    position: absolute;
    left: 0;
    top: 4px;
    height: 28px;
    width: 20px;
    
    &::before,
    &::after {
        position: absolute;
        top: 0;
        right: 0;
        content: '';
    }
    &::before {
        border-bottom: 8px solid #78AAF6;
        border-right: 8px solid transparent;
        border-bottom-left-radius: 3px;
        outline: 2px solid white;
    }
    &::after {
        border-bottom: 8px solid transparent;
        border-right: 8px solid white;
    }
    
    .text {
        color: white;
        line-height: 35px;
        font-size: 11px;
        font-weight: bold;
        text-align: center;
    }
}

.field-customer-pack .cp-status {
    text-transform: uppercase;
}

.field-customer-pack .cp-status-unconfirmed {
    color: #E89D6B;
}

.field-customer-pack .cp-status-rejected {
    color: #DD515D;
}

.field-customer-pack .cp-status-confirmed {
    color: #5DAEB7;
}


.invoice {
    padding-left: 30px;
    position: relative;
    display: block;
    line-height: 18px;

    .oms-file-icon .text {
        font-size: 9px;
    }
    
    .invoice-status {
        text-transform: uppercase;
        color: #DD515D;
    }
    
    .invoice-status.status-paid {
        color: #5DAEB7;
    }
}

.invoice + .invoice {
    margin-top: 6px;
}


.production-progress {
    display: flex;
    
    b {
        line-height: 30px;
        margin-left: 6px;
        font-size: 16px;
    }
}

.enquiry-source {

}

</style>